"use client";

import Carousel from "@/components/common/Carousel";
import FadeDiv from "@/components/common/FadeDiv";
import GailHelpsCard from "@/components/GailHelpsCard";
import Image from "next/image";
import React from "react";
import SectionTitle from "./common/SectionTitle";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

type GailHelpItems = {
  title: string;
  description: string;
  image: React.ReactNode;
}[];

const GailHelps: React.FC = () => {
  const { t } = useTranslation();

  const features: GailHelpItems = [
    {
      title: t("gailHelps.sellMore.title"),
      description: t("gailHelps.sellMore.description"),
      image: (
        <Image
          src="/icons/home/arrowsOutOfPlus.svg"
          alt="Sell More"
          width={58}
          height={58}
        />
      ),
    },
    {
      title: t("gailHelps.fiveStar.title"),
      description: t("gailHelps.fiveStar.description"),
      image: (
        <Image
          src="/icons/home/fiveStars.svg"
          alt="Five Star"
          width={58}
          height={58}
        />
      ),
    },
    {
      title: t("gailHelps.scaleMarketing.title"),
      description: t("gailHelps.scaleMarketing.description"),
      image: (
        <Image
          src="/icons/home/scaleBox.svg"
          alt="Scale Marketing"
          width={58}
          height={58}
        />
      ),
    },
    {
      title: t("gailHelps.aiExpert.title"),
      description: t("gailHelps.aiExpert.description"),
      image: (
        <Image
          src="/icons/home/chip.svg"
          alt="AI Expert"
          width={58}
          height={58}
        />
      ),
    },
    {
      title: t("gailHelps.smarterDecisions.title"),
      description: t("gailHelps.smarterDecisions.description"),
      image: (
        <Image
          src="/icons/home/lightbulb.svg"
          alt="Smarter Decisions"
          width={50}
          height={50}
        />
      ),
    },
    {
      title: t("gailHelps.shortcut.title"),
      description: t("gailHelps.shortcut.description"),
      image: (
        <Image
          src="/icons/home/shortcut.svg"
          alt="Shortcut"
          width={58}
          height={58}
        />
      ),
    },
  ];

  return (
    <div className="max-w-8xl mx-auto mb-4 md:mb-0">
      <FadeDiv>
        <SectionTitle
          title={t("gailHelps.mainTitle")}
          className="md:max-w-xl"
        />
      </FadeDiv>
      <div
        className={clsx(
          "grid",
          "gap-[1px]",
          "bg-[#DADADA]",
          "grid-cols-1",
          "md:grid-cols-2",
          "lg:grid-cols-3",
          "hidden",
          "md:grid"
        )}
      >
        {features.map((feature, index) => (
          <GailHelpsCard
            key={index}
            title={feature.title}
            description={feature.description}
            icon={feature.image}
          />
        ))}
      </div>
      <div className="w-full max-w-8xl md:hidden">
        <FadeDiv>
          <Carousel
            items={features.map((feature, index) => (
              <GailHelpsCard
                key={index}
                title={feature.title}
                description={feature.description}
                icon={feature.image}
                disableFade
              />
            ))}
            itemWidth="90%"
            showControls={true}
            showPageIndicator={true}
          />
        </FadeDiv>
      </div>
    </div>
  );
};

export default GailHelps;
